import { forwardRef } from 'react'
import { useTheme } from '@opallabs/hooks'
import type { ParagraphProps } from '../types'
import * as styles from './styles'

export { type ParagraphProps as ParagraphTextProps }

export const ParagraphText = forwardRef<HTMLParagraphElement, ParagraphProps>(
  (
    {
      children,
      className,
      color,
      lineClamp,
      theme,
      styleOverrides,
      ...htmlAttributes
    },
    ref
  ) => {
    const providedTheme = useTheme()
    return (
      <p
        className={className}
        {...htmlAttributes}
        css={[
          styles.text({
            lineClamp,
            textColorName: color,
            theme: theme || providedTheme,
          }),
          styleOverrides,
        ]}
        ref={ref}
      >
        {children}
      </p>
    )
  }
)
ParagraphText.displayName = 'Lapidary: ParagraphText'
